import { CellAction } from "./cell-action";

import { ColumnDef } from "@tanstack/react-table";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "title",
    header: "TITLE",
  },
  {
    accessorKey: "url",
    header: "LIEN",
  },
  {
    accessorKey: "thumbnail",
    header: "IMAGE",
    cell: ({ row }) => (
      <img
        src={`${row.original.thumbnail}`}
        alt={`Image for ${row.original.thumbnail}`}
        className="w-16 rounded-lg h-14"
      />
    ),
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
